// The dial codes of the four markets the app supports (NOK, SEK, DKK, GBP).
// Umami's PhoneInput country list is not importable (blocked by the package
// exports map), so numbers with other dial codes simply get no prefill.
const DIAL_CODES = ['+47', '+46', '+45', '+44'];

export interface SplitPhoneNumber {
  dialCode?: string;
  nationalNumber?: string;
}

// Dial code followed by 6-13 digits (E.164 tops out at 15 digits in total)
const PHONE_NUMBER_REGEX = /^\+\d{8,15}$/;

export const isValidPhoneNumber = (phone: string) => PHONE_NUMBER_REGEX.test(phone.replaceAll(' ', ''));

// PhoneInput reports the bare dial code (1-4 digits) once the national digits are
// deleted, so a value that short means the user has not entered a number
export const isEmptyPhoneNumber = (phone: string) => /^(\+\d{0,4})?$/.test(phone.replaceAll(' ', ''));

export const splitPhoneNumber = (phone: string | undefined): SplitPhoneNumber => {
  if (!phone) {
    return {};
  }

  const normalized = phone.replaceAll(' ', '');
  const dialCode = DIAL_CODES.find((code) => normalized.startsWith(code));

  if (!dialCode) {
    return {};
  }

  return { dialCode, nationalNumber: normalized.slice(dialCode.length) };
};
